<template>
  <page-container title="Tasks">
    <template v-if="isMobile && !adminView">
      <v-progress-linear v-if="!userData"></v-progress-linear>
      <mobile-jobs-list :search="tableSearch" v-else></mobile-jobs-list>
    </template>
    <template v-else>
      <v-row class="ma-0 mb-2 pa-2 tab-header" align-content="center">
        <v-col cols="6">
          <v-tabs height="40" v-model="selectedTab">
            <v-tab :to="{ name: 'task-list' }">List</v-tab>
            <v-tab :to="{ name: 'task-calendar' }">Calendar</v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="6" align="end">
          <feature name="jobs" variant="write" data="jobs">
            <template v-if="bulkEditing">
              <v-btn
                class="button background-color--inactive color--foreground mr-2"
                tile
                elevation="0"
                @click="bulkEditing = false"
                key="cancel-btn"
                >Cancel</v-btn
              >
              <v-btn
                class="button"
                tile
                color="primary"
                elevation="0"
                @click="bulkUpdatePopupVisible = true"
                key="action-btn"
                >Bulk update</v-btn
              >
              <v-btn icon class="ml-2" @click="bulkDeleteAction"
                ><v-icon>mdi-delete</v-icon></v-btn
              >
            </template>
            <v-btn
              v-else
              color="primary"
              class="button"
              tile
              elevation="0"
              :to="{ name: 'job-details', params: { id: 'new' } }"
              key="new-task-btn"
              >New task</v-btn
            >
          </feature>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-card
          elevation="0"
          min-width="100%"
          :loading="!adminView && userData == null"
        >
          <router-view
            :showBulkUpdate.sync="bulkUpdatePopupVisible"
            :bulkEditing.sync="bulkEditing"
            :userData="userData"
            :adminView="adminView"
            :tableSearch="tableSearch"
            ref="tasksContentView"
          ></router-view>
        </v-card>
      </v-row>
    </template>
  </page-container>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
import MobileJobsList from './components/MobileJobsList.vue'

import {
  hasAccessRightForCollection,
  AccessRightWrite,
} from '@/plugins/feature'
import { mapGetters, mapActions } from 'vuex'
import { constants, denormalized } from '@/helpers'
import { db } from '@/firebaseConfig'
export default {
  components: {
    PageContainer,
    MobileJobsList,
  },
  data: () => ({
    userData: null,
    bulkUpdatePopupVisible: false,
    bulkEditing: false,
    selectedTab: 0,
  }),
  computed: {
    ...mapGetters(['companyId', 'currentUser', 'isMobile']),

    adminView() {
      return hasAccessRightForCollection('jobs', AccessRightWrite)
    },
    tableSearch() {
      let result = []
      if (!this.adminView) {
        result = [
          ['status', 'in', constants.STATUSES_VISIBLE_FOR_EMPLOYEE],
          ['assignees', 'array-contains', this.userData],
        ]
      }
      return result
    },
  },
  created() {
    if (!this.adminView) {
      this.getUserData()
    }
  },
  methods: {
    ...mapActions(['showError', 'showSuccess']),
    bulkDeleteAction() {
      this.$refs.tasksContentView.bulkDeleteAction()
    },
    async getUserData() {
      try {
        const docSnapshot = await db
          .collection(`companies/${this.companyId}/workforce`)
          .doc(this.currentUser.uid)
          .get()
        if (!docSnapshot.exists) {
          throw 'No doc'
        }

        this.userData = denormalized.workforce(
          docSnapshot.data(),
          docSnapshot.id
        )
      } catch (error) {
        console.error(error)
        this.showError(
          '<b>Failed</b>\n' + error.message ?? 'Failed to load user information'
        )
      }
    },
  },
}
</script>

<style lang="less" scoped>
</style>